import { render, staticRenderFns } from "./DelegationCommerciale.vue?vue&type=template&id=3cd506f8"
import script from "./DelegationCommerciale.vue?vue&type=script&lang=js"
export * from "./DelegationCommerciale.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports